import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/siteContent";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-32 bg-white dark:bg-[#0A2513]"
    >
      <div className="mx-auto max-w-4xl px-6 md:px-12">
        <div className="text-center">
          <span className="inline-block text-xs uppercase tracking-[0.18em] font-semibold text-[#1F8A3A]">
            FAQ
          </span>
          <h2
            data-testid="faq-heading"
            className="mt-4 font-display text-3xl md:text-5xl font-semibold tracking-tight text-[#0E2A17] dark:text-[#F2FAF4]"
          >
            Answers, before you pick up the phone.
          </h2>
        </div>

        <div className="mt-14">
          <Accordion
            type="single"
            collapsible
            className="w-full"
            data-testid="faq-accordion"
          >
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#E3F5EA] dark:border-[#1A3925]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display text-lg md:text-xl font-medium text-[#0E2A17] dark:text-[#F2FAF4] hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#3F5549] dark:text-[#B9CDC0] text-base leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
